export default __webpack_public_path__ + "static/Google-818c09c2b664740e6cc016338e86c136.pdf";